<template>
<div  class="PF">
  <div class="header ">
     <div class="header-center">
       <div class="header-left">
         <div @click="swicthNav(0)"><router-link to="/" tag="div" ><img src="../../../static/images/logo.png" class="logo" alt="" ></router-link></div>
         <div class="header-left-div pr"   @click="swicthNav(1)"><router-link to="/about" tag="div" >About</router-link><div   :class="current==1?'active':'heder-h'"></div></div>
         <div class="header-left-div pr"   @click="swicthNav(2)"><router-link to="/products" tag="div" >Products</router-link><div  :class="current==2?'active':'heder-h'"></div></div>
         <!-- <div class="header-left-div pr"   @click="swicthNav(3)"><router-link to="/solutions" tag="div" >Solutions</router-link><div :class="current==3?'active':'heder-h'"></div></div>
         <div class="header-left-div pr"   @click="swicthNav(4)"><router-link to="/news" tag="div" >News</router-link><div :class="current==4?'active':'heder-h'"></div></div> -->
         <div class="header-left-div pr"   @click="swicthNav(5)"><router-link to="/contact" tag="div" >Contact</router-link><div :class="current==5?'active':'heder-h'"></div></div>
         <!-- <div class="header-left-div pr"   @click="swicthNav(6)"><router-link to="/vrList" tag="div" >Online Showroom</router-link><div :class="current==6?'active':'heder-h'"></div></div> -->
         <div class="header-left-div pr"  @click="swicthNav(6)" ><router-link to="/vrList" tag="div" >Download</router-link><div :class="current==6?'active':'heder-h'"></div></div>
        </div>
       <div class="header-right">
         <div class="pr headerInput" v-if="search==true">
            <input type="text" class="header-input"  v-model="keyword" placeholder="product" @keyup.enter="searchlist()" onfocus="this.placeholder=''" onblur="this.placeholder='product'">
            <i class="el-icon-close close" @click="inputshowHide()"></i>
         </div>
         <img class="header-right-icon"  v-if="search==false" src="../../../static/images/header_icon1.png" @click="inputshowHide()" alt="">
         <img class="header-right-icon" @click="switchIN(1)" style="width:1.2rem;height:1.2rem"  src="../../../static/images/header_icon3.png"  alt="">
         <img class="header-right-icon" @click="switchIN(2)" style="width:0.8rem;height:1.4rem" src="../../../static/images/header_icon2.png"  alt="">
         <!--  <img class="header-right-icon" @click="switchIN(3)" style="width:1.3rem;height:1.1rem" src="../../../static/images/header_icon4.png"  alt=""> -->
         <img class="header-right-icon" @click="switchIN(4)" style="width:1.3rem;height:1.3rem" src="../../../static/images/header_icon7.png"  alt="">
         <!-- <img class="header-right-icon" style="width:1.6rem;height:1.2rem" src="../../../static/images/header_icon5.png"  alt=""> -->
         <img class="header-right-icon" v-if="mute==false"  style="width:1.9rem;height:1.5rem" src="../../../static/images/header_icon6.png" @click="muteSwitch()"  alt="">
         <img class="header-right-icon" v-else style="width:1.9rem;height:1.5rem" src="../../../static/images/header_icon6x.png" @click="muteSwitch()"  alt="">

       </div>
     </div>
  </div>
  <div class="nav index ">
      <div class="layui-container"> 
        <!-- 公司logo -->
        <div class="nav-logo"   @click="swicthNav(0)"> <router-link to="/" tag="a" ><img src="../../../static/images/logo.png" alt="网络公司"> </router-link> </div>
      
        <div class="nav-list">
          <button> <span class=""></span><span style="display: block;"></span><span class=""></span> </button>
          <ul class="layui-nav" lay-filter="">
            <li class="layui-nav-item" :class="current==1?'phone_active layui-this':''"   @click="swicthNav(1)"><router-link to="/about" tag="a" >About</router-link></li>
            <li class="layui-nav-item" :class="current==2?'phone_active layui-this':''"   @click="swicthNav(2)"><router-link to="/products" tag="a" >Products</router-link></li>
            <!-- <li class="layui-nav-item" :class="current==3?'phone_active layui-this':''"   @click="swicthNav(3)"><router-link to="/solutions" tag="a" >Solutions</router-link></li>
            <li class="layui-nav-item" :class="current==4?'phone_active layui-this':''"   @click="swicthNav(4)"><router-link to="/news" tag="a" >News</router-link></li> -->
            <li class="layui-nav-item" :class="current==5?'phone_active layui-this':''"   @click="swicthNav(5)"><router-link to="/contact" tag="a" >Contact</router-link></li>
            <!-- <li class="layui-nav-item" :class="current==6?'phone_active layui-this':''"   @click="swicthNav(6)"><router-link to="/vrList" tag="a" >Online Showroom</router-link></li> -->
            <li class="layui-nav-item" :class="current==6?'phone_active layui-this':''"><router-link  to="/" tag="a"  >Download</router-link></li>
            <!-- <div class="header-right2"> -->
                 <!-- <div class="pr headerInput" v-if="search==true">
                    <input type="text" class="header-input" placeholder="product" v-model="keyword" @keyup.enter="searchlist()" onfocus="this.placeholder=''" onblur="this.placeholder='product'">
                    <i class="el-icon-close close" @click="inputshowHide()"></i>
                </div> -->
                <!-- <img class="header-right-icon" src="../../../static/images/header_icon1.png" @click="inputshowHide()" alt="">
                <img class="header-right-icon" style="width:0.8rem;height:1.4rem" src="../../../static/images/header_icon2.png"  alt="">
                <img class="header-right-icon" style="width:1.2rem;height:1.2rem"  src="../../../static/images/header_icon3.png"  alt="">
                <img class="header-right-icon" style="width:1.3rem;height:1.1rem" src="../../../static/images/header_icon4.png"  alt="">
                <img class="header-right-icon" style="width:1.3rem;height:1.3rem" src="../../../static/images/header_icon7.png"  alt="">
                <img class="header-right-icon" style="width:1.6rem;height:1.2rem" src="../../../static/images/header_icon5.png"  alt="">
                <img class="header-right-icon" v-if="mute==false"  style="width:1.9rem;height:1.5rem" src="../../../static/images/header_icon6.png" @click="muteSwitch()"  alt="">
                <img class="header-right-icon" v-else style="width:1.9rem;height:1.5rem" src="../../../static/images/header_icon6x.png" @click="muteSwitch()"  alt=""> -->
            <!-- </div> -->
            <span class="layui-nav-bar " style="left: 342px; top: 78px; width: 0px; opacity: 0;"></span>
          </ul>
            
        </div>
      </div>
    </div>
    <div class="nav2" style="height:5rem"></div>
 </div>
</template>
<script>
export default {
    name:'Header',
    data(){
       return {
        current:sessionStorage.getItem('header_current'),
        mute:true,
        search:false,
        padphone:false,//是否是移动端 ipad
        keyword:'',
       }
    },
    mounted(){
        let inwidth=window.innerWidth
        if(inwidth<=1024){
          this.padphone=true
        }
        if(inwidth>=1024){
          $('.PF').attr('style','height:10vh') 
        }else{
          $('.PF').attr('style','height:5rem') 
        }

              //一般直接写在一个js文件中
        layui.use(['jquery', 'element', 'carousel'], function(){
          var $ = layui.jquery
          ,element = layui.element
          ,carousel = layui.carousel

          //滚动监听
          $(window).scroll(function() {
            var scr=$(document).scrollTop();
            scr > 0 ? $(".nav").addClass('scroll') : $(".nav").removeClass('scroll');
          });


          //导航切换
          var btn = $('.nav').find('.nav-list').children('button')
          ,spa = btn.children('span')
          ,ul = $('.nav').find('.nav-list').children('.layui-nav');
          btn.on('click', function(){
            if(!$(spa[0]).hasClass('spa1')){//展开
              spa[0].className = 'spa1';
              spa[1].style.display = 'none';
              spa[2].className = 'spa3';
              $('.nav')[0].style.height =( 60 + ul[0].offsetHeight)/10 + 'rem';
            }else{//收起
              spa[0].className = '';
              spa[1].style.display = 'block';
              spa[2].className = '';
              $('.nav')[0].style.height =6+ 'rem';
            }
          });
        });
               
    },
    methods:{
      // search(){
      
      // },
      inputshowHide(){
        if(this.search==true){ //搜索框消失
          this.search=false
          if(this.padphone==true){//是ipad 移动端 控制小图标
           $('.header-right-icon').show() 
          }
        }else{ //搜索框出现
          this.search=true
          if(this.padphone==true){//是ipad 移动端  控制小图标
            $('.header-right-icon').hide() 
          }
        }
      },
      //搜索列表
      searchlist(){
          if(sessionStorage.getItem('header_current')==2){
            
             this.$router.push({ name: 'products', query: {keyword:this.keyword} });
             window.location.reload();
          }else{
            sessionStorage.setItem('header_current',2);
            this.$router.push({ name: 'products', query: {keyword:this.keyword} });
          }
      },
      muteSwitch(){
        if(this.mute==false){
          this.mute=true
          this.$tools.muted=true
          
        }else{
          this.mute=false
          this.$tools.muted=false
        }
        this.$emit("muteds",  this.mute);
      },
      switchIN(index){
        if(index==1){
          window.open('https://www.instagram.com/saudidamonsfurniture/?utm_source=qr')
        }else if(index==2){
          window.open('https://www.facebook.com/damonsfurniture')
        }else if(index==3){
          window.open('https://www.tiktok.com/@kano_office_furniture')
        }else if(index==4){
          window.open('https://www.linkedin.com/company/dmsaudi')
        } else if(index==5){
         this.swicthNav(0)
          this.$router.push({ path: '/',query: {}})
        }
      },
      swicthNav(index){
        sessionStorage.setItem('header_current',index);
        this.current=index
        if($(".nav").css("display")=='block' ){//移动端切换菜单收起列表
        var btn = $('.nav').find('.nav-list').children('button'),spa = btn.children('span');
           spa[0].className = '';
           spa[1].style.display = 'block';
           spa[2].className = '';
           $('.nav')[0].style.height =5+ 'rem';
        }
        
      },
    }
}
</script>
<style scoped>
.PF{
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  z-index: 2000;
}
 .header{
     width: 100%;
     height:10vh;
     background-color: #577db2;
     padding-bottom: 0.1rem;
 }
 .header2{
     width: 100%;
     height:10vh;
 }
 .header-center{
   width: 90%;
   height: 100%;
   margin: 0 auto;
   display: flex;
   align-items: center;
   justify-content: space-between;
   color: #ffffff;
   font-size: 1.6rem;
   font-weight: bold;
 }
 .header-left{
   display: flex;
   align-items: center;
 }
 .header-left-div {
   margin: 0 2.5rem;
   height: 10vh;
   line-height: 10vh;
   cursor: pointer;
   border-bottom: 0.3rem solid rgba(0,0,0,0.0);
   padding-bottom: 0.1rem;
 }
 .active{
   position: absolute;
   bottom: 0;
   left: 0;
   width: 100%;
   height: 0.3rem;
   background-color: #ffffff;
 }
 .logo{
   /* width: 12rem; */
   height: 2.8rem;
   cursor: pointer;
   margin-right: 2.5rem;
   margin-bottom: 1rem;
 }
 .header-right{
   display: flex;
   align-items: center;
 }
 .header-right2{
   display: flex;
   align-items: center;
   padding-top: 2rem;
   padding-bottom: 2rem;
 }
 .header-right-icon{
   width: 1.5rem;
   height: 1.5rem;
   margin-left: 2.8rem;
   cursor: pointer;
 }
 .headerInput{
   display: flex;
   align-items: center;
   background-color: #ffffff;
   padding:0  0.5rem;
   border-radius: 0.2rem;

 }
 .header-input{
   width: 20rem;
   /* height:5rem; */
   padding: 0.2rem 0;
   font-size: 1.4rem;
   color: #4c4c4c;
   border: none;
 }
.close{
  
  color: #4c4c4c;
  cursor: pointer;
  font-size: 1.8rem;
}
.heder-h{
  position: absolute;
  left: 0;
  bottom: 0;
  width: 0%;
  height: 0.3rem;
  background-color: #ffffff;
  transition: all .2s linear;
}

.header-left-div:hover .heder-h{
  width: 100%;
}
 /* //移动导航栏 */
 .nav {
  position: fixed;
  top: 0;
  left: 0;
	width: 100%;
	height:5rem;
	box-shadow: 0 0.3rem 0.3rem 0 #CCC;
	background-color: #000000;
	overflow: hidden;
	transition: 0.3s;
  z-index: 2000;
  display: none;
}
.nav2{
  display: none;
}
.nav.index {
	background: #577db2;;
	box-shadow: 0 0 0 0 rgba(0,0,0,0.05);
}
.nav.scroll {
	background: #577db2;;
	box-shadow: 0 0.3rem 0.3rem 0 rgba(0,0,0,0.05);
	transition: 0.3s
}
.nav .layui-container {
	position: relative;
	transition: all 400ms ease-out;
  border-bottom: 0.1rem solid #333333;
}
.nav .nav-logo {
	height: 100%;
	position: absolute;
	top: 0;
	left: 1.5rem;
	line-height: 5rem;
}
.nav .nav-list {
	display: inline-block;
	height:5rem;
}
.nav .nav-list button {
	width: 2.5rem;
	height: 3rem;
	position: absolute;
	top: 1.5rem;
	right: 1.5rem;
	background-color: transparent;
	border: none;
	outline: none;
	cursor: pointer;
}
.nav .nav-list button span {
	display: block;
	width: 2.5rem;
	height: 0.2rem;
	background: #ffffff;
	margin-bottom:0.6rem;
	transition: 0.5s;
}
.nav .nav-list button span.spa1 {
	transform: rotate(45deg);
}
.nav .nav-list button span.spa3 {
	transform: rotate(-45deg) translate(5px, -5px);
}
.nav .layui-nav {
	width: 100%;
	position: absolute;
	top: 6rem;
	right: 0;
	color: #000;
	background: transparent;
  font-weight: bold;
}
.nav .layui-nav .layui-nav-item {
	display: block;
	line-height: 6rem;
}
.nav .layui-nav * {
	font-size: 1.6rem;
}
 .layui-nav .layui-nav-item a {
	padding: 0 0;
	color: #ffffff;
}
.nav .layui-nav-bar, .nav .layui-nav .layui-this:after {
	height: 0.1rem;
	background-color: #333333;
}
.nav .layui-nav .layui-this a, .nav .layui-nav .layui-nav-item a:hover {
	color: #ffffff;
}
.nav .layui-nav  .phone_active a{
    color: #ffffff;
}

/*当浏览器尺寸等于1200px时候的代码：*/
@media screen and (max-device-width:1200px){
    .header{
      overflow: hidden;
    }
    .header-left-div {
      margin: 0 1rem;
       padding-bottom: 0.1rem;
    }
    .header-right2 .header-right-icon:nth-child(1){
      margin-left: 0;
    }
}
 /*当浏览器尺寸小于1200px时候的代码：*/
 @media screen and (max-width:1300px){
    .header-center{
      font-size: 1.5rem;
    }
}
@media screen and (max-width:1200px){
    .header{
      overflow: hidden;
    }
    .header-left-div {
      margin: 0 1rem;
       padding-bottom: 0.1rem;
    }
   
}
/* //小于等于768 */
@media screen and (max-width: 768px) {
  .header,.header2{
    display: none;
  }
  .nav,.nav2{
    display: block;
  }

  
  .nav .nav-list button {
    display: block;
  }
  
}





 
</style>